module.exports = __webpack_public_path__ + "static/00060.dab6b2c8.jpg";